import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-load-jobcard',
  templateUrl: './skeleton-load-jobcard.component.html',
  styleUrls: ['./skeleton-load-jobcard.component.scss']
})
export class SkeletonLoadJobcardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
